/**
 * Command-center endpoint on Skynet.Underwriting.FunctionApp (DEV-4173).
 *
 * - GET /api/command-center/conditions/heatmap — open PTD/PTC condition counts bucketed by
 *                                                outstanding age, with a per-cell severity.
 *   `includeByFile=true` additionally returns the bounded (≤1000), oldest-outstanding-first
 *   per-file drilldown (PII-min: borrower last name + loan last-4 only).
 *
 * Company-scoped by JWT; may 404/403 until the function app deploys — the calling action
 * degrades gracefully to null (skeleton → empty state, never a crash/toast).
 */
export class CommandCenterUnderwritingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConditionHeatmap({ windowDays = 90, includeByFile = false, config = {} } = {}) {
    return this.#http.get('/api/command-center/conditions/heatmap', {
      ...config,
      params: { windowDays, includeByFile },
    });
  }
}
